// extracted by mini-css-extract-plugin
export default {"whatsNewBtn":"HeaderMy_whatsNewBtn__89hqf","floatY":"HeaderMy_floatY__lnr9K","glow":"HeaderMy_glow__Va1Xg"};